<template>
  <span class="d-inline-flex align-baseline" v-if="genderIndex > -1">
    <v-icon :size="size" :color="color" v-bind="$attrs">{{
      genderOption[genderIndex].icon
    }}</v-icon>
    <span :style="{ color }" v-if="!hideLabel">{{ genderOption[genderIndex].text }} </span>
  </span>
</template>

<script>
import { genderOption } from '@/data/optionsConstants';
import { genderType } from '@/data/constants';
export default {
  name: 'genderLabel',
  props: {
    gender: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '16px',
    },
  },
  data() {
    return {
      isMale: false,
      isFemale: false,
      genderIndex: -1,
      genderOption,
    };
  },
  watch: {
    gender: {
      handler(val) {
        this.genderIndex = this.genderOption.findIndex(gender => gender.value === val);
      },
      immediate: true,
    },
  },
  computed: {
    color() {
      if (this.gender === genderType.Male) {
        return this.$vuetify.theme.themes.light.genderMale_dark;
      }
      if (this.gender === genderType.Female) {
        return this.$vuetify.theme.themes.light.genderFemale_dark;
      }
      return this.$vuetify.theme.themes.light.genderUnknown_dark;
    },
  },
};
</script>

<style lang="scss" scoped></style>
